// src/routes/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth, clearSession } from '../hooks/useAuth';
import { puedeVer, RUTA_POR_DEFECTO } from './permisos';

export const ProtectedRoute = () => {
  const { isAuthenticated, roles } = useAuth();
  const { pathname } = useLocation();

  if (!isAuthenticated) {
    clearSession();
    // 'replace' evita que el usuario pueda "volver" con la flecha del navegador
    return <Navigate to="/login" replace />;
  }

  // Sin esto, esconder el ítem del menú no sirve de nada: alcanza con escribir
  // la ruta en la barra de direcciones. (El bloqueo real igual lo hace el
  // backend en cada endpoint; esto evita mostrar una pantalla que va a fallar.)
  if (!puedeVer(pathname, roles)) {
    return <Navigate to={RUTA_POR_DEFECTO} replace />;
  }

  return <Outlet />;
};
